import React from 'react'
import { View } from 'react-native'
import { Text } from '@src/components/base'
import { StyleService, useStyleSheet } from '@src/style/service'

const MAX_BADGE_COUNT = 99

const getUnreadCountBadgeLabel = (unreadCount: number) => {
  if (unreadCount > MAX_BADGE_COUNT) {
    return `${MAX_BADGE_COUNT}+`
  }

  return `${unreadCount}`
}

interface NotificationInboxHeaderTitleProps {
  unreadCount: number
}

export const NotificationInboxHeaderTitle = ({
  unreadCount,
}: NotificationInboxHeaderTitleProps) => {
  const styles = useStyleSheet(themedStyles)

  return (
    <View style={styles.headerTitleContainer}>
      <Text type="large" bold style={styles.headerTitleText}>
        Notifications
      </Text>
      {unreadCount > 0 && (
        <View style={styles.headerBadge} testID="NotificationInbox/HeaderBadge">
          <Text type="small" bold lineSpacing="none" style={styles.headerBadgeText}>
            {getUnreadCountBadgeLabel(unreadCount)}
          </Text>
        </View>
      )}
    </View>
  )
}

const themedStyles = StyleService.create({
  headerTitleContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  headerTitleText: {
    flexShrink: 1,
  },
  headerBadge: {
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 11,
    marginLeft: 8,
    paddingHorizontal: 6,
    height: 22,
    minWidth: 22,
    backgroundColor: 'theme.like',
  },
  headerBadgeText: {
    top: 0.5,
    left: 0.5,
    color: 'theme.solid.white',
  },
})
